import React, { useState } from "react"
import {
  MessageSquare,
  CodeXml,
  Sparkles,
  MoreVertical,
  Circle,
  Square,
  SquarePen,
} from "lucide-react"

const ActionButtons = ({
  toggleAIAssistant,
  toggleCandidateChat,
  toggleNotes,
  navigateToCodeEditor,
  userRole,
  isRecording,
  onStartRecording,
  onStopRecording,
}) => {
  const [showMoreMenu, setShowMoreMenu] = useState(false)

  const handleCodeEditorClick = () => {
    navigateToCodeEditor()
    setShowMoreMenu(false)
  }

  return (
    <div className="flex items-center space-x-2 relative">
      {/* Subtle recording indicator in row */}
      {isRecording && (
        <div className="flex items-center space-x-1.5 px-2.5 py-1 rounded-full bg-red-500/5 border border-red-500/10">
          <Circle
            size={6}
            className="text-red-500 fill-red-500 animate-pulse"
          />
          <span className="text-xs text-red-400/80 font-medium">REC</span>
        </div>
      )}

      {/* AI Assistant button */}
      {userRole === "interviewer" && (
        <button
          onClick={toggleAIAssistant}
          className="p-2 rounded-full hover:bg-gray-700 transition-colors"
          title="AI Assistant"
        >
          <Sparkles size={20} />
        </button>
      )}

      {/* Candidate Chat button */}
      <button
        onClick={toggleCandidateChat}
        className="p-2 rounded-full hover:bg-gray-700 transition-colors"
        title="Chat with Candidate"
      >
        <MessageSquare size={20} />
      </button>

      {/* Only show notes button for interviewer */}
      {userRole === "interviewer" && (
        <button
          onClick={toggleNotes}
          className="p-2 rounded-full hover:bg-gray-700 transition-colors"
          title="Interview Notes"
        >
          <SquarePen size={18} />
        </button>
      )}

      {/* More menu button */}
      <div className="relative">
        <button
          onClick={() => setShowMoreMenu(!showMoreMenu)}
          className="p-2 rounded-full hover:bg-gray-700 transition-colors"
          title="More options"
        >
          <MoreVertical size={20} />
        </button>

        {/* Dropdown menu - Minimalist white panel */}
        {showMoreMenu && (
          <>
            {/* Backdrop to close menu */}
            <div
              className="fixed inset-0 z-40"
              onClick={() => setShowMoreMenu(false)}
            />

            {/* Menu content - Subtle edgy white panel */}
            <div className="absolute right-0 bottom-full mb-16 w-48 bg-white rounded-lg shadow-lg z-50 py-1 border border-gray-100">
              {/* Code Editor option */}
              <button
                onClick={handleCodeEditorClick}
                className="w-full px-3 py-2 text-left hover:bg-gray-50 flex items-center space-x-2.5 text-gray-700 transition-colors"
              >
                <CodeXml size={16} className="text-gray-500" />
                <span className="text-sm font-medium">Code Editor</span>
              </button>

              {/* Divider */}
              <div className="h-px bg-gray-100 my-1" />

              {/* Recording option */}
              {!isRecording ? (
                <button
                  onClick={() => {
                    onStartRecording()
                    setShowMoreMenu(false)
                  }}
                  className="w-full px-3 py-2 text-left hover:bg-gray-50 flex items-center space-x-2.5 text-gray-700 transition-colors"
                >
                  <Circle size={16} className="text-red-500" />
                  <span className="text-sm font-medium">Start Recording</span>
                </button>
              ) : (
                <button
                  onClick={() => {
                    onStopRecording()
                    setShowMoreMenu(false)
                  }}
                  className="w-full px-3 py-2 text-left hover:bg-gray-50 flex items-center space-x-2.5 text-gray-700 transition-colors"
                >
                  <Square
                    size={16}
                    className="text-red-500"
                    fill="currentColor"
                  />
                  <span className="text-sm font-medium">Stop Recording</span>
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default ActionButtons